import { render, staticRenderFns } from "./SuperomaticSelecter.vue?vue&type=template&id=32fc1a1a&"
import script from "./SuperomaticSelecter.vue?vue&type=script&lang=js&"
export * from "./SuperomaticSelecter.vue?vue&type=script&lang=js&"
import style0 from "./SuperomaticSelecter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports